var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"need-more-ment"},[_c('span',{staticClass:"visual"}),_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.$t('journey.targeting.layer.bookmarkGuideForEveryonePlan'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }